function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, getSortedMenuSections) {
    var h = require("panel").h;
    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    const isDataGroup = !!$attr(`single-data-group`);
    return {
      value: (h("mp-query-block", {
        "attrs": __vjadeStringifyAttrsIfObj({
          type: `properties`,
          'apply-button': `Select ${$attr(`selected`).length}`,
          'apply-button-disabled': $attr(`selected`).length === 0,
          'search-placeholder': `Search profile properties`,
          'project-id': $attr(`project-id`),
          selected: $attr(`selected`),
          label: $attr(`label`),
          'selector-icon': $attr(`selector-icon`),
          'selector-type': `button`,
          'hide-events': true,
          'multiple': true,
          'input-only': true,
          'workspace-id': $attr(`workspace-id`),
          'all-data-groups': isDataGroup,
          'single-data-group': $attr(`single-data-group`),
          'project-has-people': !isDataGroup,
          'hide-recently-viewed': true,
          'hide-section-labels': true,
          'exclude-dimension-properties': true,
          'show-select-all': true,
          'select-all-disabled': $attr(`selected`).length === 0,
          'track-name': $attr(`track-name`),
          'selectable-sensitive-properties': true,
        }),
        "on": {
          select: $helpers.handleQueryBlockSelect,
          open: $helpers.handleQueryBlockOpen,
          close: $helpers.handleQueryBlockClose,
          selectAll: $helpers.handleQueryBlockSelectAll,
        },
        "props": {
          getSortedMenuSections,
        },
      }))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "getSortedMenuSections" in locals ? locals.getSortedMenuSections : typeof getSortedMenuSections !== "undefined" ? getSortedMenuSections : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;